export default "__VITE_ASSET__C1OVkG88__"